import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import MessengerCustomerChat from 'react-messenger-customer-chat';
import StaticPostLayout from '../components/StaticPostLayout';
import InfoSection from '../components/TripInfo/yellowstone-grand-teton';
import MapSection from '../components/Maps/yellowstone-grand-teton';

class YellowstoneGrandTeton extends Component {
  render() {
    return (
      <>
        <Helmet>
          <title>Yellowstone & Grand Teton: 5-Day Road Trip Itinerary</title>
          <meta name="description" content="5-day Yellowstone and Grand Teton itinerary: Old Faithful, Grand Prismatic Spring, Grand Canyon of Yellowstone, Jenny Lake, and Cascade Canyon." />
          <meta property="og:title" content="Yellowstone & Grand Teton: 5-Day Road Trip Itinerary" />
          <meta property="og:description" content="5-day Yellowstone and Grand Teton itinerary: Old Faithful, Grand Prismatic Spring, Grand Canyon of Yellowstone, Jenny Lake, and Cascade Canyon." />
          <meta property="og:url" content="https://exploroff.com/itineraries/yellowstone-grand-teton" />
          <meta property="og:type" content="article" />
          <meta property="og:image" content="https://exploroff.com/img/yellowstone-grand-teton/yellowstone.jpg" />
          <link rel="canonical" href="https://exploroff.com/itineraries/yellowstone-grand-teton" />
          <script type="application/ld+json">{JSON.stringify({
            "@context": "https://schema.org", "@type": "BlogPosting",
            headline: "Yellowstone & Grand Teton: 5-Day Road Trip Itinerary",
            description: "5-day Yellowstone and Grand Teton itinerary covering Old Faithful, Grand Prismatic Spring, Grand Canyon of Yellowstone, and the Tetons.",
            image: ["https://exploroff.com/img/yellowstone-grand-teton/yellowstone.jpg"],
            author: { "@type": "Organization", name: "ExplorOFF" },
            publisher: { "@type": "Organization", name: "ExplorOFF", logo: { "@type": "ImageObject", url: "https://exploroff.com/img/favicon.png" } },
            mainEntityOfPage: { "@type": "WebPage", "@id": "https://exploroff.com/itineraries/yellowstone-grand-teton" }
          })}</script>
        </Helmet>
        <MessengerCustomerChat pageId="101590111335192" appId="695593052231950" />
        <StaticPostLayout
          title="Yellowstone & Grand Teton: 5-Day Road Trip"
          category="itineraries"
          slug="yellowstone-grand-teton"
          excerpt="Old Faithful, Grand Prismatic Spring, Grand Canyon of Yellowstone, and the Teton Range in five days."
          tags={['road trip', 'national park', 'wildlife']}
          readTime={12}
          mapComponent={<MapSection />}
          whereToStay={[
            { name: 'Old Faithful Inn', type: 'Iconic Lodge · Yellowstone NP', url: 'https://www.booking.com/searchresults.html?ss=Yellowstone+National+Park' },
            { name: 'Jackson Lake Lodge', type: 'Grand Teton NP Lodge', url: 'https://www.booking.com/searchresults.html?ss=Moran%2C+Wyoming' },
            { name: 'Hotels in Jackson', type: 'Gateway Town · Grand Teton', url: 'https://www.booking.com/searchresults.html?ss=Jackson%2C+Wyoming' },
          ]}
        >
          <InfoSection />
        </StaticPostLayout>
      </>
    );
  }
}

export default YellowstoneGrandTeton;
